var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAugeHellgrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.8 17.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#b0b0b0;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_122",
    className: "cls-1",
    d: "M1,8.65S5.14,1,12.4,1s11.4,7.65,11.4,7.65c0,0-4.15,7.65-11.4,7.65S1,8.65,1,8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_123",
    className: "cls-1",
    d: "M15.89,8.65c0,1.93-1.56,3.49-3.49,3.49-1.93,0-3.49-1.56-3.49-3.49s1.56-3.49,3.49-3.49c1.93,0,3.49,1.56,3.49,3.49h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugeHellgrau);
export default __webpack_public_path__ + "static/media/Auge_hellgrau.76a4208c3ef77bfb54154330945f0b12.svg";
export { ForwardRef as ReactComponent };